import { render, staticRenderFns } from "./StickinessScoreCard.vue?vue&type=template&id=f935c126&scoped=true"
import script from "./StickinessScoreCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StickinessScoreCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StickinessScoreCard.vue?vue&type=style&index=0&id=f935c126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f935c126",
  null
  
)

export default component.exports